import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FooterExtendedComponent } from './footerExtended.component';

@NgModule({
    imports: [ RouterModule, CommonModule ],
    declarations: [ FooterExtendedComponent ],
    exports: [ FooterExtendedComponent ],
})

export class FooterExtendedModule {}
